import React, { ReactNode, useMemo } from 'react';

import { CoreLibConfig, setCoreConfig } from './config';

interface Props {
  config: CoreLibConfig;
  children: ReactNode;
}

const ConfigProvider: React.FC<Props> = ({ config, children }) => {
  useMemo(() => setCoreConfig(config), [config]);
  return <>{children}</>;
};

export default ConfigProvider;
